import {useEffect} from 'react';
import {useStockCardLookupQuery} from '@/queries/stock-card';
import type {Cad, StockCardProperties} from '@/types/stock-card';

type StockCardProps = {
    properties: StockCardProperties;
    productLineCode: string;
    setPreviewLink: (previewLink: Cad | null) => void;
};

/**
 * Resolves the configured properties to a stock card and lifts its CAD files to the page, which
 * renders them beside the preview image. Nothing is drawn here.
 */
const StockCard = ({properties, productLineCode, setPreviewLink}: StockCardProps): null => {
    const stockCardQuery = useStockCardLookupQuery(properties, productLineCode);
    const cad = stockCardQuery.data?.cad ?? null;

    // Lifting this during render updates Home while React is rendering StockCard, which is unsafe
    // under concurrent rendering and warns in StrictMode. It survived while it only drove an
    // <img>; it does not survive driving a WebGL viewer.
    useEffect(() => {
        setPreviewLink(cad?.dwg || cad?.step ? cad : null);

        // StockCardLookup unmounts this as soon as the configuration goes incomplete, so this
        // cleanup is what clears the previous product from the page.
        return () => {
            setPreviewLink(null);
        };
    }, [cad, setPreviewLink]);

    return null;
};

export default StockCard;
